module.exports = __webpack_public_path__ + "img/4F5246_8C8D84_7B7C74_131611-256px.c7dc2644.png";